import { IconAlertTriangle } from "@tabler/icons-react";
import { MantineIconCell } from "../../../../mantine/mrt/components/cell/MantineIconCell";
import { THEME_VARS } from "../../../../utils/constants";

interface MissingDeliveriesInfoProps {
  numberOfDeliveries: number;
}

function MissingDeliveriesInfo({
  numberOfDeliveries
}: MissingDeliveriesInfoProps) {
  return numberOfDeliveries === 0 ? (
    <MantineIconCell
      iconColor={THEME_VARS.warning[6]}
      IconComponent={IconAlertTriangle}
      renderedCellValue="Keine Lieferungen"
    />
  ) : (
    <div className="missing-deliveries-info-container">
      <span>
        {numberOfDeliveries}&nbsp;
        {numberOfDeliveries === 1 ? "Lieferung" : "Lieferungen"}
      </span>
    </div>
  );
}

export { MissingDeliveriesInfo };
